import livanceLogo from "@/assets/livance-logo.svg";
import { LoadingDots } from "@/components/ui/loading/loading-dots";

import type { JSX } from "react";

export const Loading = (): JSX.Element => {
  return (
    // `fixed inset-0`: cobre a tela inteira mesmo quando o app já renderizou
    // conteúdo antes dele no DOM (overlay do boot, ver BootGate). `<output>` já tem
    // o papel "status" (aria-live polite).
    <output className="fixed inset-0 z-9999 flex flex-col items-center justify-center gap-3 bg-primary-400 font-poppins">
      <img alt="Logo Livance" src={livanceLogo} />
      <LoadingDots colorClassName="bg-secondary-400" />
    </output>
  );
};
